<div class="video-wrapper">
  @if (data.poster && !playing) {
    <picture class="video-poster">
      <source [srcset]="data.poster.webp" type="image/webp" />
      <img [src]="data.poster.jpg" alt="" fetchpriority="high" decoding="async" />
    </picture>
  }

  <video
    role="dialog"
    aria-modal="true"
    aria-label="Vídeo de apresentação do AYR"
    controls
    autoplay
    (playing)="playing = true"
  >
    <source [src]="data.videoUrl" type="video/mp4" />
    Sorry, your browser doesn't support embedded videos.
  </video>
</div>
